export default __webpack_public_path__ + "static/accointing-21a53f544e14b4180beec38a7a918357.png";